












































import { Adquirente, Page, Pageable } from '@/models';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { FindAdquirenteUseCase } from '@/usecases';
import axios, { CancelTokenSource } from 'axios';
import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';

	@Component
export default class SeletorDeAdquirente extends Vue {
		@Ref() campo!: HTMLInputElement
		@PropSync('value') selecionado?: Adquirente | Adquirente[] | string | string[]
		@Prop({ type: Boolean, default: false }) readonly somenteId!: boolean 
		@Prop({ type: Boolean, default: false }) substituicaoDeTitulos!: boolean
		
		adquirentes: Adquirente[] = []
		carregando = false
		busca: string | null = null
		pageable: Pageable = {
			page: 0,
			size: 3,
		}
		pagina: Page<Adquirente> | null = null
		cancelToken: CancelTokenSource | null = null
		findAdquirenteUseCase = new FindAdquirenteUseCase

		validandoSelecao = false
		

		get noDataMessage() {
			if (this.carregando) {
				return 'Carregando...'
			}
			if (!this.busca) {
				return 'Digite para consultar...'
			}
			return '$vuetify.noDataText'
		}

		get carregouTodosOsAdquirentes() {
			return this.pagina?.last || false
		}

		async pageNext() {
			this.pageable.page = !this.pageable.page
				? 1
				: this.pageable.page += 1
			await this.find()
		}

		get itemValueKey() {
			return this.somenteId ? 'id' : 'razaoSocialOuNome'
		}


		@Watch('busca', { deep: true })
		onChangeBusca(busca: string, buscaAnterior: string) {
			this.pageable = {
				...this.pageable,
				page: 0,
			}
			if (busca === buscaAnterior) {
				this.carregando = false
				return
			}
			this.find()
		}

		async find() {
			if (this.cancelToken) this.cancelToken.cancel()
			try {
				this.carregando = true
				this.cancelToken = axios.CancelToken.source()
				this.pagina = await this.findAdquirenteUseCase.findAll({
					page: this.pageable.page || 0,
					size: this.pageable.size,
					busca: this.busca || undefined,
				},
				{
					cancelToken: this.cancelToken.token,
				})
				this.pagina.content.filter(adquirente => adquirente.ativo === true).forEach(adquirente => {
					if (this.adquirentes.some(({ id }) => adquirente.id === id)) return
					this.adquirentes.push(adquirente)
				})
				this.carregando = false
			} catch (error: any) {
				if (axios.isCancel(error)) return
				this.pagina = null
				AlertModule.setError(error)
			} finally {
				this.carregando = false
			}
		}


		focus() {
			this.campo.focus()
		}

		@Watch('selecionado')
		async onChangeSelecionado(novo: any) {
			if (!this.substituicaoDeTitulos) return
			if (!novo) return

			if (Array.isArray(novo)) return

			try {
				this.validandoSelecao = true

				const adquirenteId = typeof novo === 'object' && novo?.id ? novo.id : novo

				const temSubstituto = await this.findAdquirenteUseCase.validarAdquirenteDeSubstituicao(adquirenteId)

				if (!temSubstituto) {
					this.selecionado = undefined
					AlertModule.setError('Para pagamentos com substituição de títulos, o adquirente precisa estar cadastrado também como cliente.')

					this.$nextTick(() => {
						this.selecionado = null as any
						this.busca = null

						const ac: any = this.$refs.campo
        ac?.blur?.()
        ac?.focus?.()
					})
				}
			} catch (error: any) {
				if (axios.isCancel(error)) return
				AlertModule.setError(error)
				this.$nextTick(() => {
					this.selecionado = null as any
					this.busca = null
				})
			} finally {
				this.validandoSelecao = false
			}
		}
}
